import { render, staticRenderFns } from "./CustomerSearch.vue?vue&type=template&id=da94fcd8"
import script from "./CustomerSearch.vue?vue&type=script&lang=js"
export * from "./CustomerSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports